<template>
    <div>
        <div class="field-container">
           <div class="field">
                <label for="" class="label">Attack Technique</label>    
                <input type="text" class="input" :value="monk.attackTechniqueName" @input="updateAttackTechniqueName">
            </div>
        </div>
        <div class="field-container">
            <h2>Move Technique</h2>
            <div class="field">
                <label for="" class="label">Name</label>    
                <input type="text" class="input" :value="monk.moveTechnique.name" @input="updateMoveTechniqueName">
            </div>
            <div class="field">
                <label for="" class="label">Type</label>    
                <input type="text" class="input" :value="monk.moveTechnique.type" @input="updateMoveTechniqueType">
            </div>
            <div class="field">
                <label for="" class="label">Range</label>    
                <input type="text" class="input" :value="monk.moveTechnique.range" @input="updateMoveTechniqueRange">
            </div>
            <div class="field">
                <label for="" class="label">Target</label>    
                <input type="text" class="input" :value="monk.moveTechnique.target" @input="updateMoveTechniqueTarget">
            </div>
            <div class="field full">
                <label for="" class="label">Effect</label>                
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="monk.moveTechnique.effect" @input="updateMoveTechniqueEffect"></textarea>
            </div>
        </div>
    </div>        
</template>

<script>
import { mapState } from 'vuex';

export default {  
    props: {
        
    },
    components: {

    },
    data: function() {
        return {
            
        };
    },
    computed: {
        ...mapState({
            monk: state => state.monk,
        }),
    },
    methods: {           
        updateAttackTechniqueName(e) {
            this.$store.commit('monk/setAttackTechniqueName', e.target.value);
        },
        updateMoveTechniqueName(e) {
            this.$store.commit('monk/setMoveTechniqueName', e.target.value);
        },
        updateMoveTechniqueType(e) {
            this.$store.commit('monk/setMoveTechniqueType', e.target.value);
        },
        updateMoveTechniqueRange(e) {
            this.$store.commit('monk/setMoveTechniqueRange', e.target.value);
        },
        updateMoveTechniqueTarget(e) {
            this.$store.commit('monk/setMoveTechniqueTarget', e.target.value);
        },
        updateMoveTechniqueEffect(e) {
            this.$store.commit('monk/setMoveTechniqueEffect', e.target.value);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
